import { jsx as d } from "react/jsx-runtime";
import { Close as S } from "@campoint/odi-ui-icons";
import { IconButton as x, Icon as h } from "@chakra-ui/react";
import { createContext as B } from "@chakra-ui/react-utils";
import { forwardRef as l, omitThemingProps as v, useMultiStyleConfig as M, StylesProvider as T, chakra as _, useStyles as m } from "@chakra-ui/system";
import { cx as u, __DEV__ as n } from "@chakra-ui/utils";
import * as f from "react";
import { UtilStyledIcon as I } from "../../utils/utilStyledIcon.mjs";
import { useOdiCard as g } from "./use-odi-card.mjs";
const [E, C] = B({
  strict: !0,
  name: "OdiCardContext",
  errorMessage: "useOdiCardContext: `context` is undefined. Seems you forgot to wrap card components in `<OdiCard />`"
}), P = l(
  ({ children: t, ...s }, r) => {
    const a = v(s), e = M("OdiCard", s), i = {
      ...e.card
    }, o = g(s), c = {
      ...o
    };
    return /* @__PURE__ */ d(E, { value: c, children: /* @__PURE__ */ d(T, { value: e, children: /* @__PURE__ */ d(
      _.section,
      {
        ref: r,
        __css: i,
        ...o.getCardProps(a),
        className: u("odi-card", s.className),
        children: t
      }
    ) }) });
  }
);
n && (P.displayName = "OdiCard");
const b = l(
  (t, s) => {
    const { className: r, ...a } = t, e = u("odi-odi-card__close-button", r), o = {
      ...m().closeButton
    }, { setCloseButtonMounted: c } = C();
    return f.useEffect(() => (c(!0), () => c(!1)), [c]), /* @__PURE__ */ d(
      x,
      {
        icon: /* @__PURE__ */ d(h, { as: S }),
        ref: s,
        variant: "daemon",
        ...a,
        sx: o,
        className: e
      }
    );
  }
);
n && (b.displayName = "OdiCardCloseButton");
const D = l(
  (t, s) => {
    const { className: r, ...a } = t, e = u("odi-odi-card__header", r), o = {
      ...m().header
    };
    return /* @__PURE__ */ d(
      _.header,
      {
        ref: s,
        className: e,
        __css: o,
        ...a
      }
    );
  }
);
n && (D.displayName = "OdiCardHeader");
const w = l((t, s) => {
  const { className: r, ...a } = t, e = u("odi-odi-card__top", r), o = {
    ...m().top
  }, { setTopMounted: c } = C();
  return f.useEffect(() => (c(!0), () => c(!1)), [c]), /* @__PURE__ */ d(_.div, { ref: s, className: e, __css: o, ...a });
});
n && (w.displayName = "OdiCardTop");
const F = l(
  (t, s) => {
    const { className: r, ...a } = t, e = u("odi-odi-card__title", r), o = {
      ...m().title
    }, { titleId: c, setTitleMounted: y, isTopMounted: p, isCloseButtonMounted: N } = C(), O = N && !p ? { px: 14 } : {};
    return f.useEffect(() => (y(!0), () => y(!1)), [y]), /* @__PURE__ */ d(
      _.h3,
      {
        ref: s,
        className: e,
        id: c,
        __css: o,
        ...O,
        ...a
      }
    );
  }
);
n && (F.displayName = "OdiCardTitle");
const H = (t) => {
  const s = m();
  return /* @__PURE__ */ d(
    I,
    {
      customClassname: "odi-card__icon",
      styleConfig: s.icon,
      ...t
    }
  );
};
n && (H.displayName = "OdiCardIcon");
const R = l(
  (t, s) => {
    const { className: r, ...a } = t, e = u("odi-odi-card__description", r), o = {
      ...m().description
    }, { descriptionId: c, setDescriptionMounted: y } = C();
    return f.useEffect(() => (y(!0), () => y(!1)), [y]), /* @__PURE__ */ d(
      _.div,
      {
        ref: s,
        className: e,
        id: c,
        __css: o,
        ...a
      }
    );
  }
);
n && (R.displayName = "OdiCardDescription");
const j = l((t, s) => {
  const { className: r, ...a } = t, e = u("odi-card__body", r), o = {
    ...m().body
  };
  return /* @__PURE__ */ d(_.div, { ref: s, __css: o, ...a, className: e });
});
n && (j.displayName = "OdiCardBody");
const k = l(
  (t, s) => {
    const { className: r, ...a } = t, e = u("odi-card__footer", r), o = {
      ...m().footer
    };
    return /* @__PURE__ */ d(
      _.footer,
      {
        ref: s,
        __css: o,
        ...a,
        className: e
      }
    );
  }
);
n && (k.displayName = "OdiCardFooter");
export {
  P as OdiCard,
  j as OdiCardBody,
  b as OdiCardCloseButton,
  R as OdiCardDescription,
  k as OdiCardFooter,
  D as OdiCardHeader,
  H as OdiCardIcon,
  F as OdiCardTitle,
  w as OdiCardTop
};
